import React from 'react';

function Header({ showCart }) {
	return (
		<header id='home'>
			<nav>
				<div className='wrapper'>
					<h1>Earring In The Name</h1>
					<ul className='navBar'>
						<li className='navBarLink'>
							<a href='#home'>home</a>
						</li>
						<li className='navBarLink'>
							<a href='#products'>products</a>
						</li>
						<li className='navBarLink'>
							<a href='#contact'>contact</a>
						</li>
					</ul>
					<button className='cartButton' onClick={showCart}>
						cart
					</button>
				</div>
			</nav>

			<h1 className='hiddenHeader'>Earring In The Name</h1>
			<a href='#products' className='scroll'>
				Shop New Arrivals ∨
			</a>
		</header>
	);
}
export default Header;
